import { CommonModule, formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgbModal, NgbModule, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { ScorePopupComponent } from '../../shared/popups/score-popup/score-popup.component';
import { CommonDataSharingService } from '../../shared/services/common-data-sharing.service';
import { BrowserStorageService } from '../../shared/services/common/browser-storage.service';
import { ConfirmationPopupComponent } from '../../shared/services/common/popups/confirmation-popup/confirmation-popup.component';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { UserService } from '../../shared/services/user.service';
import { api } from '../../utils/endpoints';
import { confirmationMessages } from '../../utils/popup-messages';
import { fileDirectories } from '../../utils/view-settings';
import { DetailsFeedComponent } from '../details-feed/details-feed.component';
import { EditFeedComponent } from '../pages/setting/edit-feed/edit-feed.component';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommentFeedComponent } from '../../shared/popups/comment-feed/comment-feed.component';
import { LikesListComponent } from '../../shared/popups/likes-list/likes-list.component';
import { SearchPopupComponent } from '../../shared/popups/search-popup/search-popup.component';
import { AppSyncService } from '../../shared/services/appsync/appsync.service';
import { SafeHtmlPipe } from '../../shared/validators/safe-html.pipe';
import { LIMIT, MAX_SIZE } from '../../utils/constants';
import { ICONS } from '../../utils/svg-icons';

@Component({
  selector: 'app-featured-feed',
  imports: [CarouselModule, CommonModule, NgbModule, InfiniteScrollModule, RouterLink, SafeHtmlPipe],
  providers: [NgbModal],
  templateUrl: './featured-feed.component.html',
  styleUrl: './featured-feed.component.scss',
})
export class FeaturedFeedComponent {
  feedList: any;
  fileDirectoriesPath: any = fileDirectories.profile;
  customOptions: OwlOptions = {
    loop: false,
    autoplay: false,
    center: false,
    dots: true,
    nav: true,
    navText: [
      '<img src="assets/images/ic_arrow_left.svg" class="arrow__icon" alt="Previous" />',
      '<img src="assets/images/ic_arrow_left.svg" class="arrow__icon right" alt="Next" />',
    ],
    autoHeight: false,
    autoWidth: true,
    responsive: {
      0: {
        items: 1,
      },
    },
  };

  userDetail: any;
  @Input() usedFor: any;
  @Input() reload: any;
  selectedDateFilters: any = { from: null, to: null };
  selectedFilters: any;
  appliedFilters: any = [];
  userInfo: any;
  pagination = { limit: LIMIT, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };
  @Output() pageChange = new EventEmitter<number>();
  @Output() feeds = new EventEmitter<any>();
  elementList: any = [];
  isInitialized = false;
  searchContant: any;
  DetailsFeed: any;
  private appsyncEndpoint = (environment as any).appsyncEndpoint;
  private apiKey = (environment as any).apiKey;
  PostsCountsList: any;
  private offcanvasService = inject(NgbOffcanvas);

  private subscription: Subscription | undefined;
  private subscribeToLike: Subscription | undefined;
  apiHit = false;
  lastScrollTop: any = 0;
  ICONS = ICONS;
  constructor(
    private _commonDataService: CommonDataSharingService,
    private storageService: BrowserStorageService,
    private ref: ChangeDetectorRef,
    private _activatedRoute: ActivatedRoute,
    private _toast: ToastrService,
    private _apiCalls: ApiCallsService,
    private _ngbModal: NgbModal,
    private userService: UserService,
    private _router: Router,
    private appsyncService: AppSyncService,
  ) {
    if (this.usedFor == 'searchFeed') {
      this.searchContant = this._commonDataService.getSearchQuery();
    }
  }

  ngOnChanges(objectPropertys: any) {
    // Subscribe to the search query from the service
    this._commonDataService.searchQuery$.subscribe((query) => {
      if (query) {
        this.searchContant = query;
        this.pagination.skip = 0;
        this.feedList = [];
        this.getFeedList();
        return;
      }
    });
    const userdata = this.storageService.getItem('userDetail');
    if (userdata) {
      this.userInfo = JSON.parse(userdata);
    }
    this._activatedRoute.queryParams.subscribe((params: any) => {
      if (params.filter && params.selectedFilters) {
        this.selectedFilters = JSON.parse(params.selectedFilters);
        this.appliedFilters = JSON.parse(params.selectedFilters);
      }

      if (params.selectedDateFilters) {
        this.selectedDateFilters = JSON.parse(params.selectedDateFilters);
      }

      this.feedList = [];
      this.elementList = this._commonDataService.elementList;
      if (this.usedFor == 'myFeed' && this.elementList.length == 0) {
        this._commonDataService._getElementList(null, 1).subscribe((element: any) => {
          this.pagination.skip = 0;
          this.feedList = [];
          this.getFeedList();
        });
      } else {
        this.pagination.skip = 0;
        this.feedList = [];
        this.getFeedList();
      }
    });

    this.userService.user.subscribe((user: any) => {
      this.userDetail = user ?? null;
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.attachSubscription();
    }, 3000);
  }

  getDetail(data: any) {
    let modalRef = this._ngbModal.open(DetailsFeedComponent, {
      backdrop: 'static',
      keyboard: false,
      size: 'galleryPopup',
      scrollable: false,
    });
    modalRef.componentInstance.query = { key: 'value', anotherKey: 'featuredFeed', usedFor: this.usedFor };
    modalRef.componentInstance.data = data;

    modalRef.result.then((result: any) => {
      if (result) {
        this.pagination.skip = 0;
        this.feedList = [];
        this.getFeedList();
      }
    });
  }
  getFeedList() {
    if (this.apiHit == false) {
      this.apiHit = true;
      console.log(this.usedFor, 'this.usedFor');
      let apiUrl =
        this.usedFor == 'Review' || this.usedFor == 'PendingReview' ? api._FeedPeer : this.usedFor == 'searchFeed' ? api._FeedSearch : api._FeedList;
      console.log(apiUrl, 'this.usedFor');
      this._apiCalls.post(apiUrl, this._getRequest()).subscribe({
        next: (res: any) => {
          if (res) {
            this.apiHit = false;
            this.pagination.totalItems = res?.data.count;
            this.pageChange.emit(this.pagination.totalItems);
            this.pagination.row = res?.data.posts.length;
            this.pagination.text = 'No record found!';
            if (this.usedFor != 'PendingReview' && this.usedFor != 'home') {
              let postIds: any = [];
              if (this.pagination.skip == 0) {
                this.feedList = res?.data.posts;
              }
              res.data.posts.map((value: any, index: any) => {
                postIds.push(JSON.stringify(value.id));
                if (index + 1 === res.data.posts.length) {
                  this.postCount(postIds);
                }
                if (this.pagination.skip != 0) {
                  this.feedList.push(value);
                }
              });
            } else {
              this.feedList = res?.data.posts;
              let postIds: any = [];
              res.data.posts.map((value: any, index: any) => {
                postIds.push(JSON.stringify(value.id));
                if (index + 1 === res.data.posts.length) {
                  this.postCount(postIds);
                }
              });
            }
            this.feedList.forEach((value: any, index: any) => {
              value?.postScores?.map((value1: any) => {
                if (value1.userId == this.userDetail?.id) {
                  this.feedList[index].canBeScored = false;
                }
              });
            });
            this.feeds.emit(res?.data.count);
            setTimeout(() => {
              this.isInitialized = true;
              this.ref.detectChanges(); // Trigger re-render
            }, 1000);
          }
        },
        error: (err: any) => {
          console.log(err);
        },
      });
    }
  }
  private _getRequest(): HttpParams {
    let currentPage = this.pagination.skip + 1;
    // this.pagination.skip = currentPage;
    let params: any = {};
    if (this.selectedFilters != null) {
      if (this.selectedFilters && this.selectedFilters.length > 0) {
        let value: any[] = this.selectedFilters;
        let sportID: any[] = [];
        let elementID: any[] = [];
        let status: any[] = [];
        let elementList: any[] = this._commonDataService.elementList;
        value.map((data: any) => {
          if (data != 'Pending' && data != 'Not required' && data != 'Rejected' && data != 'Completed') {
            const index = elementList.findIndex((element) => element.id === data);
            if (index != -1) {
              elementID.push(data.toString());
            } else {
              sportID.push(data.toString());
            }
          } else {
            let values: any = data == 'Not required' ? 'not_required' : data.toLowerCase();
            status.push(values.toString());
          }
        });
        if (sportID.length > 0) {
          params['sportId'] = sportID;
        }
        if (elementID.length > 0) {
          params['elementId'] = elementID;
        }
        if (status.length > 0) {
          params['reviewStatus'] = status;
        }
      }
    }
    if (this.selectedDateFilters && this.selectedDateFilters.from != null && this.selectedDateFilters.to != null) {
      params['createdAtFrom'] = formatDate(new Date(this.selectedDateFilters.from), 'yyyy-MM-dd', 'en-US');
      params['createdAtTo'] = formatDate(new Date(this.selectedDateFilters.to), 'yyyy-MM-dd', 'en-US');
    }
    if (this.usedFor == 'myFeed') {
      if (this.userInfo?.id) {
        params['userId'] = this.userInfo?.id;
      } else {
        const userdata = this.storageService.getItem('userDetail');
        if (userdata) {
          this.userInfo = JSON.parse(userdata);
          params['userId'] = this.userInfo?.id;
        }
      }
    }

    params['limit'] = this.pagination.limit;
    if (this.usedFor == 'home') {
      params['limit'] = 3;
      params['isFeatured'] = true;
      params['sortOrder'] = 'DESC';
      params['sortBy'] = 'featuredAt';
    }
    if (this.usedFor == 'PendingReview') {
      params['limit'] = 3;
    }
    if (this.usedFor == 'featureFeed') {
      params['isFeatured'] = true;
      params['sortOrder'] = 'DESC';
      params['sortBy'] = 'featuredAt';
    }
    if (this.usedFor == 'Review' || this.usedFor == 'PendingReview') {
      params['forExpert'] = true;
    }

    if (this.usedFor == 'searchFeed') {
      params['search'] = this.searchContant;
    }
    if (this.usedFor == 'myFeedUser') {
      params['userId'] = this._activatedRoute.snapshot.paramMap.get('id');
    }
    params['page'] = currentPage;
    return params;
  }
  openScoreUserPopup(data: any): void {
    if (this.userDetail?.id) {
      const addEditUserPopup = this._ngbModal.open(ScorePopupComponent, {
        size: 'lg',
        centered: true,
        scrollable: false,
        backdrop: 'static',
        keyboard: false,
      });
      addEditUserPopup.componentInstance.filtersList = data;
      addEditUserPopup.result.then((result: any) => {
        if (result) {
          this._apiCalls.patch(api._FeedPost + '/' + data.id + '/assign-score', result).subscribe({
            next: (res: any) => {
              this._toast.success('Updated successfully');
              this.feedList = [];
              this.getFeedList();
            },
            error: (error: any) => {
              console.log(error);
            },
          });
        }
      });
    } else {
      this.moveToRegister();
    }
  }

  moveToRegister() {
    this._router.navigate(['/auth/signup']);
  }
  deleteFeed(data: any): void {
    let modalRef = this._ngbModal.open(ConfirmationPopupComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      size: 'small confirmationPopup',
      centered: true,
    });
    modalRef.componentInstance.confirmationMessage = confirmationMessages.deactivateFeed;
    modalRef.result.then((res: any) => {
      if (res) {
        this._apiCalls.delete(api._FeedPost + '/' + data.id, { id: data.id }).subscribe({
          next: (res: any) => {
            this._toast.success('Feed has been removed successfully');

            this.pagination.skip = 0;
            this.feedList = [];
            this.getFeedList();
          },
          error: (error: any) => {
            console.log(error);
          },
        });
      }
    });
  }
  editFeed(data: any): void {
    const offcanvasRef = this.offcanvasService.open(EditFeedComponent, {
      position: 'end',
      backdrop: true,
    });
    offcanvasRef.componentInstance.feedDetails = data;
    offcanvasRef.result.then((res: any) => {
      if (res) {
        this.feedList = [];
        this.getFeedList();
      }
    });
  }
  onScroll(e: any) {
    if ((e.currentScrollPosition > this.lastScrollTop || this.lastScrollTop == 0) && e.currentScrollPosition != this.lastScrollTop) {
      if ((this.pagination.skip + 1) * 10 > this.pagination.totalItems || this.apiHit == true) {
        return;
      }
      this.lastScrollTop = e.currentScrollPosition;
      this.pagination.skip = this.pagination.skip + 1;
      this.getFeedList();
    }
  }
  userSearch(data: any) {
    this._router.navigate(['/user/feed/' + data?.userId]);
  }

  openCommentList(data: any) {
    const offcanvasRef = this.offcanvasService.open(CommentFeedComponent, {
      position: 'end',
      backdrop: true,
    });
    offcanvasRef.componentInstance.DetailsFeed = data;
    offcanvasRef.result.then((res: any) => {
      if (res) {
        if (res == true) {
          this.feedList = [];
          this.getFeedList();
        }
      }
    });
  }
  editEventReload() {
    this.feedList = [];
    this.getFeedList();
  }
  onSearchClick() {
    const offcanvasRef = this.offcanvasService.open(SearchPopupComponent, {
      // position: 'end',
      panelClass: 'offcanvas offcanvas-top search_height',
      // backdrop: true,
    });
  }
  openLikeList(data: any) {
    const offcanvasRef = this.offcanvasService.open(LikesListComponent, {
      position: 'end',
      backdrop: true,
    });
    offcanvasRef.componentInstance.postId = data.id;
  }
  postCount(listOfPost: any) {
    // let array: any = JSON.stringify(listOfPost);
    const mutation = `query getPostsCounts {
        getPostsCounts(postIds: [${listOfPost}],currentUserId:\"${this.userDetail?.id}\") {
            items {
            commentCount
            isCurrentUserLiked
            likeCount
            postId
          }
        }
      }`;
    return fetch(this.appsyncEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': this.apiKey,
      },
      body: JSON.stringify({ query: mutation }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.errors) {
          throw new Error(JSON.stringify(data.errors));
        }
        this.PostsCountsList = data.data.getPostsCounts?.items || [];
        this.feedList = this.feedList.map((item: any) => {
          // Find the matching item in array2
          const match = this.PostsCountsList.find((entry: any) => entry.postId === item.id);

          // If a match is found, update commentCount and likeCount; otherwise, keep existing values
          return {
            ...item,
            commentCount: match ? match.commentCount : item.commentCount || 0,
            likeCount: match ? match.likeCount : item.likeCount || 0,
            isCurrentUserLiked: match ? match.isCurrentUserLiked : item?.isCurrentUserLiked || false,
          };
        });
        return data;
      })
      .catch((error) => {
        console.error('Error adding comment:', error);
        throw error;
      });
  }
  likeFeeds(postid: any, userId: any, data: any, i: any) {
    if (!data.isCurrentUserLiked) {
      this._commonDataService.likeFeed(postid, userId);
    } else {
      this._commonDataService.unlikeFeed(postid, userId);
    }
  }
  attachSubscription() {
    this.subscription = this.appsyncService.subscribeToComments('', this.userDetail?.id).subscribe({
      next: (data) => {
        this.feedList.map((item: any, i: any) => {
          if (data?.data?.commentSubscription?.comment?.postId == item.id) {
            this.feedList[i].commentCount = data?.data?.commentSubscription?.postCounts?.commentCount;
          }
        });
      },
    });
    this.subscribeToLike = this.appsyncService.subscribeToLike('', this.userDetail?.id).subscribe({
      next: (data) => {
        this.feedList.map((item: any, i: any) => {
          if (data?.data?.likeSubscription?.postCounts?.postId == item.id) {
            if (data?.data?.likeSubscription?.postCounts?.isCurrentUserLiked || data?.data?.likeSubscription?.like?.userId == this.userDetail?.id) {
              this.feedList[i].isCurrentUserLiked = !this.feedList[i].isCurrentUserLiked;
            } else {
              this.feedList[i].isCurrentUserLiked = false;
            }
            this.feedList[i].likeCount = data?.data?.likeSubscription?.postCounts?.likeCount;
          }
        });
      },
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.subscribeToLike?.unsubscribe();
  }
}
